import React from 'react';
import SVGImage from '../layout/SVGImage';

interface CancleButtonProps {
  text: string;
  disabled: boolean;
  submitted?: boolean;
  className?: string;
  testId?: string;
  onClick?: () => void;
}

export const CancleButton: React.FC<CancleButtonProps> = ({
  text,
  disabled,
  submitted,
  testId,
  className,
  onClick,
}) => {
  const bgSubmitted = 'disabled:bg-dark-3 disabled:text-white';
  const bgDisabled = 'disabled:bg-dark-9 disabled:text-dark-5';

  return (
    <button
      type="button"
      data-testid={testId}
      className={`noto-14-medium ${submitted ? bgSubmitted : disabled ? bgDisabled : ''} flex h-[46px] w-[151px] cursor-pointer items-center justify-center rounded-[50px] bg-teal-light leading-[24px] text-white hover:bg-dark-7 ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
      <SVGImage
        width={20}
        height={20}
        className="ml-[25px] fill-current"
        name={'arrow-west'}
      ></SVGImage>
    </button>
  );
};
